/* eslint-disable react/no-multi-comp */
import React, { useMemo } from 'react'

import KeyValues, { KeyValue } from 'components/KeyValues'
import { getFormattedPrice } from 'util/numbers'
import NavigatableIntegrationWidgetCard from 'components/integrations/NavigatableIntegrationWidgetCard'
import { getTimestampDisplayString } from 'util/date'

import ShopifyAddress from './ShopifyAddress'

export default function ShopifyDetail({
  className,
  data: { customer: { orders } = {}, orderUrls, shop },
  doNavigatableClearState,
  navigatableState,
}) {
  const { id } = navigatableState || {}
  const order = useMemo(
    () => orders && orders.find(({ id: orderId }) => id === orderId),
    [orders, id]
  )
  if (!order) return null
  const shippingShopifyAddress = order.shipping_address

  return (
    <NavigatableIntegrationWidgetCard.Detail
      className={className}
      onBack={doNavigatableClearState}
      title={`Order #${order.order_number}`}
    >
      <KeyValues>
        {order.id && (
          <KeyValue
            title="Order"
            value={
              orderUrls ? (
                <a
                  href={orderUrls[order.id]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  #{order.order_number}
                </a>
              ) : (
                order.id
              )
            }
          />
        )}
        {order.created_at && (
          <KeyValue
            title="Date"
            value={getTimestampDisplayString(order.created_at)}
          />
        )}
        {order.fulfillment_status && (
          <KeyValue title="Fulfillment" value={order.fulfillment_status} />
        )}
        {order.total_price && (
          <KeyValue
            title="Total price"
            value={getFormattedPrice(order.total_price, shop.currency)}
          />
        )}
        {order.shipping_address && (
          <KeyValue
            title="Shipping address"
            value={<ShopifyAddress address={shippingShopifyAddress} />}
            singleline={false}
          />
        )}
      </KeyValues>
    </NavigatableIntegrationWidgetCard.Detail>
  )
}
